import { Theme } from "@mui/material/styles";

// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(17),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "28px",
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
    oddRow: {
      backgroundColor: "#f3f3f3",
    },
    crewLabelCol: {
      minWidth: 110,
      textAlign: "left",
      display: "inline-block",
    },
    crewColonCol: {
      width: 24,
      display: "inline-flex",
      justifyContent: "center",
    },
    crewValueCol: {
      minWidth: 80,
      display: "inline-block",
    },
    crewColVisitDate: {
      textAlign: "left",
    },
    crewColStatus: {
      textAlign: "left",
    },
    crewColDeductions: {
      textAlign: "left",
    },
  })
);
